// JSON Schema specification URLs (for documentation)
export const JSON_SCHEMA_DRAFT_07_URL =
  'https://json-schema.org/draft-07/schema';
export const JSON_SCHEMA_DRAFT_2019_09_URL =
  'https://json-schema.org/draft/2019-09/schema';
export const JSON_SCHEMA_REFERENCE_URL =
  'https://json-schema.org/understanding-json-schema/reference';

// JSON Schema version identifiers (for $schema property in schemas)
// References: https://json-schema.org/understanding-json-schema/reference/schema#schema
export const JSON_SCHEMA_DRAFT_07 = 'http://json-schema.org/draft-07/schema#';
export const JSON_SCHEMA_DRAFT_2019_09 =
  'https://json-schema.org/draft/2019-09/schema';

// JSON Schema version strings (for schema generation options)
export const JSON_SCHEMA_VERSION_DRAFT_07 = 'draft-07';
export const JSON_SCHEMA_VERSION_DRAFT_2019_09 = 'draft-2019-09';
